import React from 'react';
import botIcon from '../assets/Bot.jpg'; // ✅ Use your custom icon

import './WhatsAppChatWidget.css'; // ✅ External CSS for cleanliness

function WhatsAppChatWidget() {
  return (
    <div className="whatsapp-widget-container">
      <div className="rope">
        <a
          href="https://wa.me/919949337308?text=Hi%20Spark%20AI%20Team%2C%20I'm%20interested%20in%20your%20courses!"
          className="bot-icon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={botIcon} alt="Chat Bot" />
        </a>
      </div>
      <div className="chat-bubble">💬 Chat with us!</div>
    </div>
  );
}

export default WhatsAppChatWidget;
